import GuideMeTitleBar from 'src/components/GuideMeTitleBar';
import { informationIcon } from 'src/utils/icons';

export const poModal = {
  title: <GuideMeTitleBar title="Search PO" />,
  content: (
    <div className="font-semibold text-sm">
      <p className="mb-2">
        Enter the entire PO number from the scanned or printed receipt, then press "Enter" on your
        keyboard or click "Next."
      </p>
      <p className="mb-2">Don't see your PO? </p>
      <p className="mb-2">Filter the list by entering the Supplier name.</p>
      <p className="mb-2"> Filter the list by entering item numbers or descriptions.</p>
      <p className="flex items-center">
        Click
        <span className="mr-1 ml-1">{informationIcon}</span>
        to view items on the record
      </p>
    </div>
  ),
};

export const receiptModal = {
  title: <GuideMeTitleBar title="Choose Receipt" />,
  content: (
    <div className="font-semibold text-sm">
      <p className="mb-2">
        Select an existing receipt that matches the receipt you need to work with then click "Next."
      </p>
      <p className="mb-2">
        Don't see your receipt? Press "Enter" on your keyboard or click "Next."
      </p>
      <p className="flex items-center">
        Click
        <span className="mr-1 ml-1">{informationIcon}</span>
        to view items on the record
      </p>
    </div>
  ),
};

export const closePoAttachModal = {
  title: (
    <GuideMeTitleBar
      title="Cannot Attach to Existing Receipt"
      className="font-bold text-sm text-white"
    />
  ),
  content: (
    <div className="font-semibold text-sm p-3">
      <p className="mb-3">This receipt is closed. No further receiving activity may occur.</p>
      <p className="mb-3">
        The most recent receipt record for this PO will be opened for your review.
      </p>
      <p className="mb-3">Please click "OK" to continue</p>
    </div>
  ),
};

export const closePoStatusModal = {
  title: (
    <GuideMeTitleBar title="Cannot Create New Receipt" className="font-bold text-sm text-white" />
  ),
  content: (
    <div className="font-semibold text-sm p-3">
      <p className="mb-3">This PO is closed. No further receiving activity may occur.</p>
    </div>
  ),
};

export const guideMeSteps = [poModal];
